import type { ModelSocialIntegrationEmailParsingRuleWithTags } from '@app/api/SocialIntegrationEmailParsingRule';

export const ruleInitialState: ModelSocialIntegrationEmailParsingRuleWithTags =
  {
    Id: 0,
    SourceEmailsList: null,
    CheckSpam: false,
    ExtractFullName: false,
    ExtractPhone: false,
    ExtractGender: false,
    ExtractLanguage: false,
    ExtractEmail: false,
    AssignTags: [],
    TagExtractionKeywordList: [],
    FixedTags: [],
    IsOn: false,
  };
